import { useIsTemplate } from "@/hooks/useIsTemplate.tsx";
import { useUser } from "@/hooks/useUser.tsx";
import { isKickstarterAccount } from "@/utils/isKickstarterAccount.ts";

export function useTemplateLock() {
  const { isTemplate: isRealTemplate } = useIsTemplate();
  const { currentProject } = useUser();

  const isLocked =
    isRealTemplate &&
    !isKickstarterAccount(currentProject?.accountType ?? null);

  return { isLocked, isRealTemplate };
}
